import { DatoCMSServiceError, useAppErrors } from "components/AppErrors";
import { useConfiguration } from "config";
import { useEffect, useState } from "react";
import { useQuerySubscription } from "react-datocms";

// TODO: We need default text and a timeout on this subscription.
// Someone on a slow connection should not have to wait for the latest realtime copy updates from our CMS
// just to see the dang page.
export const useDatoQuerySubscription = <QueryResponseType>(query: string, crashOnError?: boolean) => {
    const config = useConfiguration();
    const { raiseError } = useAppErrors();
    const [isVisible, setIsVisible] = useState(!document.hidden);

    useEffect(() => {
        const handleVisibilityChange = () => setIsVisible(!document.hidden);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    const { data, error } = useQuerySubscription<QueryResponseType>({
        enabled: isVisible,
        query,
        token: config.datoCms.key,
        preview: config.datoCms.preview,
        environment: config.datoCms.environment,
    });

    if (crashOnError && isVisible && error && !data) {
        raiseError(new DatoCMSServiceError(error, "A DatoCMS Query Error Occured"));
    }

    return {
        data,
        error,
    };
};
